export const PLAN_OPTIONS = [
  { value: "m1", label: "MaturaMax 1" },
  { value: "m5", label: "MaturaMax 5" },
  { value: "m10", label: "MaturaMax 10" },
  { value: "m20", label: "MaturaMax 20" },
  { value: "m50", label: "MaturaMax 50" },
];

export const STATUS_CHIP = {
  conectado: { label: "Conectado", cls: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30" },
  aguardando_qr: { label: "Aguardando QR", cls: "bg-amber-500/15 text-amber-300 border-amber-500/30" },
  desconectado: { label: "Sessão caiu", cls: "bg-red-500/15 text-red-300 border-red-500/30" },
};
